<template>
  <div class="my">
    <div class="myDetail">
      <div class="topImg">
        <img :src="bg" style="width:100%" alt="" />
      </div>
      <div class="myContent">
        <div class="userInfo">
          <div class="phone_and_img">
            <img :src="wxInfo.user.headImage" class="headImage" alt="" />
            <div class="phone">
              {{ wxInfo.user.userName }}
            </div>
          </div>
          <div class="star_and_integral">
            <div class="star item">
              <div class="label">通过率</div>
              <div class="value">{{ wxInfo.user.qrate | formatQrate }}</div>
            </div>
            <div class="star item">
              <div class="label">星级</div>
              <div class="value">{{ wxInfo.user.star }}</div>
            </div>
            <div class="integral item">
              <div class="label">积分</div>
              <div class="value">{{ wxInfo.user.integral }}</div>
            </div>
          </div>
        </div>
        <div class="linkContent">
          <van-cell-group>
            <van-cell
              v-for="(item, index) in iconList"
              :key="index"
              is-link
              @click="go(item.url)"
              class="custom-cell"
            >
              <template #icon>
                <img :src="item.icon" alt="" class="customIcon" />
              </template>
              <template #title>
                <span class="custom-title">{{ item.title }}</span>
              </template>
            </van-cell>
          </van-cell-group>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getUserByOpenid } from '../../api/user'
import { formatTime } from '../../util/index'
import store from '../../store/index'
export default {
  created() {
    const wxInfo = store.getters.userInfo
    this.wxInfo = { ...wxInfo }
    this.getUserInfo(wxInfo.user.openid)
  },
  filters: {
    formatQrate(val) {
      let value = parseFloat(val)
      return Math.floor(value) + '%'
    }
  },
  mounted() {},
  data() {
    return {
      bg: require('../../assets/images/bg.png'),
      wxInfo: {}, // wx 获取的本地信息
      iconList: [
        {
          title: '个人信息',
          icon: require('../../assets/images/svg/info.svg'),
          url: '/my/info'
        },
        {
          title: '答卷记录',
          icon: require('../../assets/images/svg/record.svg'),
          url: '/my/record'
        },
        {
          title: '奖励记录',
          icon: require('../../assets/images/svg/reward.svg'),
          url: '/my/reward'
        },
        {
          title: '我的推广',
          icon: require('../../assets/images/svg/share.svg'),
          url: '/my/myShare'
        },
        {
          title: '系统建议',
          icon: require('../../assets/images/svg/advice.svg'),
          url: '/my/advice'
        },
        {
          title: '关于我们',
          icon: require('../../assets/images/svg/about.svg'),
          url: '/my/about'
        }
      ]
    }
  },
  methods: {
    go(path) {
      this.$router.push(path)
    },
    fmt(val) {
      const fmt = formatTime(val)
      return `${fmt.year}-${fmt.month}-${fmt.day}`
    },
    getUserInfo(openid) {
      getUserByOpenid({ openid }).then(res => {
        const {
          phone,
          star,
          sex,
          integral,
          profession,
          address,
          diploma,
          birthday,
          qrate
        } = res.data
        // 数据库更新本地信息
        this.$set(this.wxInfo.user, 'phone', phone)
        this.$set(this.wxInfo.user, 'star', star)
        this.$set(this.wxInfo.user, 'sex', sex)
        this.$set(this.wxInfo.user, 'integral', integral)
        this.$set(this.wxInfo.user, 'profession', profession)
        this.$set(this.wxInfo.user, 'address', address)
        this.$set(this.wxInfo.user, 'diploma', diploma)
        this.$set(this.wxInfo.user, 'qrate', qrate)
        this.$set(this.wxInfo.user, 'birthdayStr', this.fmt(birthday))
        localStorage.setItem(
          'sdInfo',
          JSON.stringify({
            ...this.wxInfo,
            isEdit: 1,
            isFllow: 0
          })
        )
      })
    }
  }
}
</script>

<style lang="stylus">
.my{
  background: #F2F2F2;
  min-height: 100vh;
  .myDetail {
    padding-bottom: 30px;
    .topImg{
      height: 550px;
    }
    .myContent {
      position: relative;
      padding: 0 30px;
      top: -350px;
      .userInfo {
        position: relative;
        background: #fff;
        box-shadow: 0px 5px 24px 0px rgba(0, 31, 73, 0.1);
        border-radius: 10px;
        padding-bottom: 50px;
        height: 300px;
        .phone_and_img {
          position: relative;
          top: -55px;
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
          .headImage {
            width: 110px;
            height: 110px;
            border-radius: 50%;
            padding: 2px;
            background: #fff;
            line-height: 110px;
            text-align: center;
          }
          .phone {
            margin-top: 20px;
            font-size: 30px;
            color: #333;
            font-weight: bold;
            width: 80%;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
            text-align: center;
          }
        }
        .star_and_integral {
          display: flex;
          align-items: center;
          .star{
            border-right: 2px solid rgba(0, 0, 0, 0.1)
          }
          .item {
            flex-basis: 50%;
            text-align: center;
            .label {
              font-size: 30px;
              color:#666666;
              font-weight: bold;
            }
            .value {
              font-size: 53px;
              font-weight: bold;
              color: #333333;
              margin-top: 1px
            }
          }
        }
      }
      .linkContent {
        margin-top: 30px;
        box-shadow: 0px 5px 24px 0px rgba(0, 31, 73, 0.1);
        border-radius: 10px;
        overflow: hidden;
        .custom-cell {
          padding: 35px 30px;
          align-items: center;
          .custom-title {
            font-size: 32px;
            color: #333;
            font-weight: bold;
          }
        }
        .van-cell__title {
          height: 40px;
          line-height: 40px;
        }
        .customIcon {
          width: 40px;
          height: 40px;
          margin-right: 20px;
        }
      }
    }
  }
}
</style>
